import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  bg: {
    translation: {
      // Room names and descriptions
      "double-standard-deluxe": "Двойна стая стандарт DeLuxe",
      "double-sea-deluxe": "Двойна стая изглед море DeLuxe",
      "double-sea-superior-deluxe": "Двойна стaя море Superior DeLuxe",
      "junior-suit-deluxe": "Junior Suite DeLuxe",
      "apartment-deluxe": "Апартамент DeLuxe",
      "double-standard-park": "Двойна стая стандарт",
      "double-standard-sea": "Двойна стая изглед море",
      "double-standard-sea-superior": "Двойна стaя море Superior ",
      "junior-suit": "Junior Suite",
      "boutique-apartment": "Бутиков апартамент",
      "double-standard-deluxe-description":
        "Изцяло реновирани, съчетаващи стилен дизйн и съвременни технологии, стаите разполагат със спалня / king size / или две единични легла.",
      "double-sea-deluxe-description":
        "Изцяло реновирани, съчетаващи стилен дизйн и съвременни технологии, стаите предлагат завладяваща морска гледка. Разполагат със спалня / king size / или две единични легла.",
      "double-sea-superior-deluxe-description":
        "Просторни и комфортни, изцяло реновирани, съчетаващи стилен дизйн и съвременни технологии, стаите предлагат завладяваща морска гледка. Разполагат със спалня / king size / и разтегателен диван.",
      "junior-suit-deluxe-description":
        "Изцяло обновени, отличаващи се с изискана атмосфера и модерен дизайн, апартаментите тип junior suite се състоят от спалня и просторна всекидневна, сляти в едно обширно помещение, с панорамна гледка към морето. Разполагат със спалня / king size / и разтегателен диван.",
      "apartment-deluxe-description":
        "Изцяло обновени и разположени на последния девети етаж на хотела, апартаментите се отличават с изискан интериор и характерен дизай. Състоят се от хол и спалня и предлагат неповторима панорамна гледка към морския бряг и комплекса. Разполагат със спалня / king size / и разтегателен диван.",
      "double-standard-park-description":
        "Просторни и светли, двойните стаи стандарт, съчетават комфортен дизайн и всички удобстава за пълноценен престой. Стаите разполагат с две единични легла.",
      "double-standard-sea-description":
        "Елегантно обзаведени, двойните стаи с изглед към морето, осигуряват всички съвременни удобстава. Отличават се с уникалната си гледка към морето. Стаите разполагат с две единични легла.",
      "double-standard-sea-superior-description":
        "Двойните стаи Superior предлагат защеметяващ гледка към морето и панорамен изглед към центъра на комплекса. Разполагат със спалня / king size / и разтегателен диван.",
      "junior-suit-description":
        "Апартаментите тип junior suite се състоят от спалня и просторна всекидневна, сляти в едно обширно помещение, с панорамна гледка към морето. Разполагат със спалня / king size / и разтегателен диван.",
      "boutique-apartment-description":
        "Този луксозен бутиков апартамент с великолепен изглед към морето е разположен на 9-ия етаж. Проектиран в стилен дизайн с впечатляващ декор, бутикът се състои от 2 спални, две бани с душ, отворена всекидневна зона с кухня, три балконa с изглед към морето, трапезария и огромен диван, разположен пред 75 инчов телевизор. ",
      sea: "Море",
      park: "Парк",

      // Tabs
      home: "Начало",
      about: "За нас",
      accommodation: "Настаняване",
      events: "Събития",
      offers: "Оферти",
      reviews: "Ревюта",
      gallery: "Галерия",
      contact: "Контакти",
      services: "Удобства",
      sport: "Отдих и Спорт",
      room: "Стаи",
      rooms: "Стаи",

      // Admin tabs
      "all-offers": "Всички оферти",
      "create-offer": "Създай оферта",
      vouchers: "Ваучери",
      "approve-reviews": "Одобри ревюта",

      // Home
      welcome: "Добре дошли в",
      "hotel-admiral": "Хотел Адмирал",
      "one-sentence-about":
        "Добре дошли в Hotel Admiral – емблематичният 5-звезден хотел на Златни пясъци, разположен на самия морски бряг. Тук съвременният лукс, безупречното обслужване и впечатляващите гледки към Черно море се съчетават в едно незабравимо преживяване.",
      "one-sentence-about-2":
        "Открийте свят на комфорт, кулинарни удоволствия, релакс и специални моменти, създадени да останат с вас дълго след края на ваканцията.",

      // About
      "about-text-one":
        "След мащабната си трансформация Hotel Admiral се утвърждава като един от най-престижните хотели по българското Черноморие. Елегантният дизайн, модерните удобства и отличната локация на първа линия създават атмосфера, в която всяка подробност е внимателно обмислена.",
      "about-text-two":
        "Независимо дали търсите спокойна почивка, семейна ваканция или специален повод за празнуване, Admiral предлага преживяване, което надхвърля очакванията.",
      "about-text-three": "",

      // Rooms
      "rooms-description-1":
        "Всяка стая и апартамент в Hotel Admiral е създадена с внимание към детайла, за да осигури усещане за простор, спокойствие и уют. Съвременният интериор, естествената светлина и внимателно подбраните удобства превръщат всяко настаняване в истинско удоволствие.",
      "rooms-description-2":
        "Събудете се с гледка към морето и започнете деня си в атмосфера на комфорт и елегантност.",

      // Dining intro
      "dining-intro-1":
        "Кулинарното преживяване в Hotel Admiral е пътешествие през разнообразни вкусове и вдъхновения от световната кухня. Нашите ресторанти и барове предлагат внимателно подбрани менюта, висококачествени продукти и изискана атмосфера за всеки повод.",
      "dining-intro-2":
        "От богати закуски до изискани вечери с гледка към морето – всяко хранене е създадено, за да се превърне в специален момент.",
      "own-beach": "Плаж",
      "outdoor-pool": "Басейн",
      parking: "Паркинг",
      "pool-table": "Билярд",
      "lobby-bar": "Лоби бар",
      "grill-service": "Грил",
      "piano-bar-service": "Пиано бар",
      "rent-bicycle-service": "Наем на велосипед",
      "amore-service": "aMore Moonlight",
      confectionery: "Виенска сладкарница",
      "confectionery-working-hours": "Работно време - 09:00 - 23:00",

      "bar-mezzanine": "Lounge Piano bar",
      fitness: "Фитнес",
      vault: "Сейф",
      "currency-exchange": "Обменно бюро",
      restaurant: "Admiral",
      restaurants: "Ресторанти",
      conference: "Конферентни зали",
      laundry: "Пералня",
      wifi: "Интернет",
      breakfast: "Закуска",
      spa: "AquaBliss Спа Център",
      minibar: "Минибар",
      ergonomic: "Ергономичен матрак",
      "TV-55": "Цифрова телевизия 55″",
      "TV-75": "Цифрова телевизия 75″",
      nespresso: "Кафемашина Nespresso",
      cosmetics: "Козметика Aqua dellËlba",
      AC: "Климатик",
      balcon: "Балкон",
      "TV-32": "Цифрова телевизия 32″",
      armchair: "Разтегателен фотьойл",
      "coffee-machine": "Кафемашина",
      couch: "Диван",
      "touch-light": "Touch осветление",

      // Sport
      "admiral-beach": "Плаж Адмирал",
      "admiral-beach-text-1":
        "Разположен само на крачки от плажа, Hotel Admiral предлага директен достъп до златистия пясък и красотата на Черно море. Просторните зони около басейна създават идеалната обстановка за слънчеви дни и безгрижни летни моменти.",
      "admiral-beach-text-2":
        "Тук всяка гледка, всеки изгрев и всеки залез се превръщат в част от вашата ваканционна история.",
      "admiral-beach-working-hours": "Работно време: 08:00 - 17:30",
      "outdoor-swimming-pool": "Външен басейн",
      "outdoor-swimming-pool-text":
        "Големият външен басейн пред хотела, разположен на самия плаж, е едно от любимите места за отдих на посетителите на хотела. Оборудван с многобройни чадъри и удобни шезлонги, басейнът дава възможност на посетителите си да се насладят на морският бриз и шума на вълните, на метри от рецепцията на хотела.",
      "outdoor-swimming-pool-working-hours": "Работно време: 08:00 - 17:00",
      gym: "Фитнес зала",
      "spa-text-1":
        "Подарете си време за себе си в AquaBliss Spa – пространство, посветено на релаксацията, възстановяването и хармонията между тяло и ум. Съчетавайки модерни терапии и вдъхновяваща атмосфера, SPA центърът предлага цялостно преживяване за сетивата.",
      "spa-text-2":
        "Отпуснете се в зоните за релакс, насладете се на възстановяващи процедури и открийте ново усещане за баланс и спокойствие.",
      "gym-text-1":
        "Поддържайте своя ритъм и по време на почивката. Модерният фитнес център и разнообразните възможности за активен начин на живот ви позволяват да съчетаете релаксацията с движението.",
      "gym-text-2":
        "Защото истинският баланс започва тогава, когато тялото и умът са в хармония.",
      "gym-working-hours": "Работно време: 08:00 - 20:00",
      "indoor-swimming-pool": "Вътрешен минерален басейн",
      "indoor-swimming-pool-text":
        "За приятния и релаксиращ престой на своите гости, Хотел Адмирал е осигурил вътрешен басейн с минерална вода, достъпен през дъждовните дни, разположен на самостоятелен етаж в сградата.",
      "indoor-swimming-pool-working-hours": "Работно време: 08:00 - 20:00",
      "bicycle-rent": "Наем на велосипед",
      "bicycle-rent-text":
        "Наемете велосипед - това е чудесен начин да прекарате активно деня и уикенда. Колоезденето е забавен, ефективен и лесен начин за придвижване из Златни пясъци - точно както правят местните жители! Дори и да въртите педалите само няколко часа, карането на колело е незаменимо преживяване за Златни пясъци. Най-добрият ефективен начин за придвижване из курорта е с велосипед. Ако се интересувате от разглеждане на забележителности с велосипед, имаме няколко чудесни предложения за велосипедни обиколки. Наемането на велосипед в Златни пясъци е доста лесно. Отдаваме велосипеди под наем за един час или за един ден, въпреки че най-често срещаният наем е за до 3 часа. Когато наемате велосипед, трябва да внесете депозит.",
      "bicycle-rent-working-hours": "Работно време - 24/7",

      // Events
      parties: "Сватби и фирмени тържества",
      "parties-text-1":
        "Хотел Адмирал разполага с многофункционална зала подходяща за балове, сватби и фирмени тържества.",
      "parties-text-2":
        "Екипът на хотела ще откликне с идеи и професионализъм за перфектната организация и провеждане на събитието.",
      conferences: "Конференции и бизнес срещи",
      "conferences-text-1":
        "От бизнес срещи и конференции до частни тържества и специални събития – Hotel Admiral предлага елегантни пространства, модерно оборудване и професионално обслужване във всеки детайл.",
      "conferences-text-2":
        "Създаваме среда, в която идеите се развиват, а важните моменти се превръщат в незабравими спомени.",
      "conferences-text-3": "",
      "conferences-text-4": "",

      "check-availability": "Провери наличност",
      "contact-us": "Свържи се с нас",
      "useful-links": "Полезни линкове",
      "email-address": "Имейл адрес",
      name: "Име",
      "last-name": "Фамилия",
      subject: "Тема",
      message: "Съобщение",
      "send-message": "Изпрати съобщение",
      telephone: "Телефон",
      email: "Имейл",
      address: "Адрес",
      fax: "факс",
      "add-review": "Добави ревю",
      send: "Изпрати",
      "general-terms": "Общи условия",
      privacy: "Политика за поверителност",
      terms: "Условия за ползване",
      seminars: "Семинари",
      "check-in": "Настаняване",
      "check-out": "Напускане",
      children: "Деца",
      child: "Дете",
      guests: "Гости",
      book: "Запази",
      beds: "Легла",
      "room-size": "Размер на стаята",
      capacity: "Капацитет на стаята",
      price: "Цена",
      night: "Вечер",
      "night-singular": "нощувка",
      "nights-plural": "нощувки",
      all: "Всички",
      hotel: "Хотел",
      pool: "Басейн",
      dining: "Заведения",
      bar: "Барове",
      beach: "Плаж",
      "room-details": "Детайли за Стаята",
      azzurro: "Azzurro",
      "asian-samba": "Asian samba Bar & Dinner",
      amore: "aMore Moonlight",
      tortuga: "Tortuga Beach Club",
      "affair-bbq": "Affair BBQ Beach",

      "more-about-us": "Повече за нас",
      "hotel-address": "9007 Златни пясъци, Варна",
      "all-rights-reserved": "Хотел Адмирал. Всички права запазени",
      "see-more": "Виж повече",
      "clients-say": "Какво казват клиентите",

      // Restaurants page
      "restaurant-text":
        "Основният ресторант предлага богато разнообразие от международни специалитети, шоу кукинг станции и тематични вечери, които превръщат всяко хранене в истинско кулинарно събитие.",
      "restaurant-text-2":
        "Веднъж седмично може да се насладите на тематичните ни Българска и Италианска вечеря",
      "restaurant-working-hours": "Работно време:",
      "restaurant-working-hours-1": "Закуска на блок-маса – 07:30 – 10:00 ч.",
      "restaurant-working-hours-2": "Обяд на блок-маса – 12:30 – 14:30 ч.",
      "restaurant-working-hours-3": "Вечеря на блок-маса – 18:00 – 21:00 ч.",
      "lobby-bar-text":
        "Разположен в сърцето на хотела, нашият лоби бар предлага богат избор от кафе специалитети, освежаващи коктейли , премиум напитки, идеални за прохладен релакс след дълъг ден или за среща с приятели.",
      "lobby-bar-working-hours": "Работно време - 24/7",
      "confectionery-text":
        "Място за сладки удоволствия, ароматно кафе и моменти на спокойствие през целия ден.",
      "bar-mezzanine-text":
        "Стилна вечерна атмосфера, авторски коктейли и музика, които превръщат всяка вечер в специално преживяване.",
      "bar-mezzanine-text-2": "",
      "bar-mezzanine-text-3": "",
      "bar-mezzanine-working-hours": "Работно време - 20:30 - 22:30",
      "swim-up": "Swim-up Pool Бар",
      "swim-up-text":
        "Swim-up Pool Барът на хотел Адмирал е перфектното място за освежаваща почивка и незабравими летни моменти. Насладете се на уникалното преживяване да отпивате коктейли и освежаващи напитки, без да напускате басейна. Нашият бар предлага разнообразие от екзотични коктейли, свежи сокове и леки закуски, които ще удовлетворят вашите вкусове, докато се наслаждавате на слънцето и водата. В идеална комбинация от релакс и забавление, Swim-up Pool Барът създава идеалната атмосфера за почивка и забавление. Заповядайте и се насладете на лятото с стил в Swim-up Pool Бара на хотел Адмирал!",
      "swim-up-working-hours": "Работно време - 09:00 - 18:00",
      "azzurro-text":
        "Вдъхновен от Средиземноморието, Azzurro съчетава свежи вкусове, елегантна атмосфера и великолепна морска гледка за едно незабравимо гастрономическо преживяване.",
      "azzurro-text-2":
        "1 безплатна вечеря за гости с престой от минимум 7 нощувки - с предварителна резервация минимум 1 ден преди това на рецепция",
      "asian-samba-text":
        "Модерна интерпретация на азиатската кухня с богати аромати, изискана презентация и селекция от любими вкусове от Далечния изток.",
      "asian-samba-text-2": "",
      "amore-text":
        "Представяме ви едно спиращо дъха изживяване, което ще ви разтърси и ще ви пренесе в свят на вълшебство - нашата ексклузивна романтична вечеря на плажа, организирана в ресторант aMore Moonlight, разположен на плажа пред хотел Адмирал. Когато се настаните на интимната си маса на брега на морето, украсена с деликатна светлина на свещи и изящни цветни аранжировки, ще бъдете посрещнати от нашия топъл и внимателен персонал, който се грижи всеки момент от вечерта ви да бъде изпълнен с вълшебство. Независимо дали празнувате специален повод, изненадвате партньора си с искрен жест или просто се отдавате на незабравимо преживяване, нашата Романтична вечеря на плажа в ресторант aMore Moonlight е олицетворение на романтиката и лукса. Потопете се в красотата на природата, изисканата кухня и блажената връзка с любимия човек. Резервирайте масата си сега на рецепцията и ни позволете да създадем вечер, която завинаги ще се запечата в сърцата ви, оставяйки ви спомени, които ще пазите цял живот.",
      "amore-text-2":
        "1 безплатна вечеря за гости с престой от минимум 7 нощувки - с предварителна резервация минимум 1 ден преди това на рецепция.",
      "amore-text-3":
        '"Amore moonlight" - вечеря на свещи е възможна през високия сезон (юли, август) и според метеорологичната прогноза',
      "tortuga-text":
        "А ла карт surf&turf ресторант - с предварителна резервация срещу допълнително заплащане. Единствено гостите на хотел Aдмирал ползват специална отстъпка от 10% от цените в менюто. Пригответе се да разкриете пълното преживяване на Tortuga - от споделеното празнуване до задушевната трапеза и благополучието.                                                                           През този сезон ще имате възможност да се впуснете в кулинарното ни пътешествие като никое друго, тъй като сме подготвили много нови попълнения в менюто ни, както и новото ни меню за закуска. Очакваме ви!",
      "tortuga-text-2": "",
      "tortuga-text-3": "",
      "affair-bbq-text": "Плажен Grill Bar",

      "azzurro-working-hours-1": "Късна закуска 10:30 - 12:00ч.",
      "azzurro-working-hours": "Обяд 12:30 - 14:30ч.",
      "azzurro-working-hours-2": "Вечеря  19:30 - 22:30ч.",
      "asian-samba-working-hours": "Вечеря 19:00 - 22:00ч.",
      // "asian-samba-working-hours-2": "Бар - до 00:30ч.",
      "amore-working-hours": "Вечеря 20:30 - 22:30ч.",
      "amore-note": "Ресторантът работи през юли и август",
      "affair-working-hours": "Обяд 12:30 - 14:30ч.",
      "tortuga-working-hours": "Работно време: 10:00 - 00:00ч.",

      payment: "Плащане",
      pay: "Плати",
      "card-details": "Детайли на картата",
      details: "Детайли",
      "payment-success": "Успешно плащане",
      "payment-failed": "Плащането е неуспешно",
      pricing: "Цени",
      meters: "м²",
      "booking-summary": "Обобщение",
      bgn: "лв.",
      view: "Гледка",
      showerhead: "Душ (кабина)",
      tv: "Телевизор",
      conditioner: "Климатик",
      dryer: "Сешоар",
      phone: "Телефон",
      adults: "Възрастни",
      wrong: "Възникна проблем.",
      "send-review-success": "Успешно изпратихте вашия отзив!",
      "send-email-success": "Успешно изпратихте вашето съобщение!",
      "send-email-fail": "Възникна проблем с изпращането на вашето съобщение!",
      "no-offers": "Няма намерени оферти.",
      "invalid-period": "Моля изберете валиден период.",
      reservations: "Резервации",
      cancellation: "Анулиране на резервация",
      "ref-number": "Референтен номер",
      "ref-not-found": "Невалиден референтен номер",
      "booking-cancelled": "Резервацията е анулирана",
      apply: "Приложи",
      "not-found": "Няма намерен ваучер.",
      "voucher-expired": "Ваучерът е изтекъл",
      "wrong-room-type": "Ваучерът не може да бъде използван за този тип стая",
      voucher: "Ваучер",
      "voucher-success": "Ваучерът беше успешно приложен.",
      "no-room-found": "Няма свободни стаи за избрания период.",
      size: "Площ",
      "capacity-single": "Капацитет",
      "total-price": "Обща цена",
      continue: "Продължи",
      "dates-were-booked": "Избраните дати са заети.",
      "no-rooms": "Няма свободни стаи за избрания период.",
      "view-room": "Виж стаята",

      "our-rooms": "Нашите стаи",

      "required-field": "Полето е задължително!",
      "room-number": "Брой стаи",
      "year-cap": "(до 11.99г)",
      "rooms-and-suites": `Стаи & Апартаменти`,

      "valid-name": "Моля, въведете вашето име.",
      "valid-email": "Моля, въведете валиден имейл адрес.",
      "valid-text": "Моля, въведете текст.",
      "additional-services": "Допълнителни услуги",
      "choose-adults": "Моля, изберете брой възрастни.",
      "room-single": "стая",
      "already-paid": "Резервацията вече е платена.",
      "cannot-cancel":
        "Резервацията не може да бъде анулирана. Моля, свържете се с нас за съдействие.",
      "type-reference-number": "Моля, въведете референтен номер.",
      "already-cancelled": "Резервацията вече е анулирана.",
      subscribe: "Абонирай се",
      newsletter: "Бюлетина",
      "invalid-email": "Невалиден имейл адрес",
      subscribers: "Абонати",
      "subscribe-success": "Успешно се абонирахте за нашите новини!",
      reserve: "Резервирай",
      "food-board": "Изхранване",
      "bed-and-breakfast": "Закуска",
      "half-board": "Закуска и вечеря",
      "full-board": "Закуска, обяд и вечеря",
      "all-light": "All-inclusive light",
      sqm: "м2",
      "send-inquiry": "Изпрати запитване",
      "ultra-all-inclusive": "Luxury Ultra All Inclusive",
      "ultra-all-inclusive-text-1":
        "Нашата концепция Luxury Ultra All Inclusive е създадена, за да ви позволи да се насладите на всеки момент без компромиси. Разнообразна гастрономия, премиум напитки, развлечения и внимателно подбрани услуги са включени в едно цялостно преживяване.",
      "ultra-all-inclusive-text-2":
        "Всичко, от което се нуждаете, е да се отпуснете и да се насладите на почивката си.",
      "final-cta-title": "Discover the Luxury. Discover Admiral.",
      "final-cta-text-1":
        "Позволете си повече от обикновена ваканция. Потопете се в свят на комфорт, елегантност и специално отношение на самия морски бряг.",
      "final-cta-text-2": "Вашето 5-звездно преживяване започва тук.",
      "enjoy-dream-vacation": "Вашето 5-звездно преживяване започва тук.",

      "voucher-min-nights":
        "Ваучерът може да се използва при резервации от минимум {{minNights}} нощувки ",

      gallery_all: "Всички",
      gallery_hotel: "Хотел",
      gallery_rooms: "Стаи",
      gallery_wiener_cafe: "Виенско кафе",
      gallery_asian_restaurant: "Азиатски ресторант",
      gallery_azzurro: "Azzurro",
      gallerry_piano_bar: "Пиано бар",
      gallerry_pool_bar_and_beach: "Басейн & Плаж",
      gallerry_fitness_and_spa: "Фитнес & СПА",

      authenticating_payment: "Плащането се верифицира",
      cant_accomodate:
        "Избраните стаи нямат капацитет за {{adults}} възрастни. Моля, изберете повече стаи!",
      cant_accomodate_with_children:
        "Избраните стаи нямат капацитет за {{adults}} възрастни и {{children}} деца. Моля, изберете повече стаи!",
      ny_min_stay: "Минимален престой от 3 нощувки",
    },
  },
  en: {
    translation: {
      "double-standard-deluxe": "Double DeLuxe room",
      "double-sea-deluxe": "Double DeLuxe room with a sea view",
      "double-sea-superior-deluxe": "Double sea side superior Deluxe",
      "junior-suit-deluxe": "Junior suite DeLuxe",
      "apartment-deluxe": "DeLuxe Apartment SV",
      "double-standard-park": "Double room ‒ Standard",
      "double-standard-sea": "Double room with a sea view",
      "double-standard-sea-superior": "Double room with a sea view Superior",
      "junior-suit": "Junior Suite",
      "boutique-apartment": "Boutique Apartment",
      "double-standard-deluxe-description":
        "Fully renovated, combining a stylish design and modern technologies, the rooms are furnished with a king size bed or two single beds.",
      "double-sea-deluxe-description": `Fully renovated, combining a stylish design and modern technologies, the rooms command a striking sea view. All rooms have a king size bed or two single beds.`,
      "double-sea-superior-deluxe-description":
        "Spacious, comfortable and fully renovated, combining stylish design with modern technologies, the rooms offer a captivating sea view. The rooms are furnished with a king size bed and a sofabed.",
      "junior-suit-deluxe-description":
        "Fully renovated, distinguished for their elegant  atmosphere and modern design, the Junior suites consist of a bedroom and a spacious living-room in an open plan, with a panoramic sea view. Furnished with a king size bed and a sofabed. ",
      "apartment-deluxe-description":
        "Fully renovated and located on the last ninth floor of the hotel, these suites are distinguished for their sophisticated interior and signature design. They consist of a sitting room and a bedroom and afford an unsurpassable panorama of the beach and the resort. Furnished with a king size bed and a sofabed.",
      "double-standard-park-description":
        "Spacious and light, the standard double rooms sport a comfortable design and all the conveniences for a fulfilling stay. The rooms are furnished with two single beds. ",
      "double-standard-sea-description":
        "Elegantly furnished, the double rooms with a view of the sea guarantee all modern conveniences and comforts. Distinguished for the unique view of the sea they afford. The rooms are furnished with two single beds.",
      "double-standard-sea-superior-description":
        "The Superior double rooms offer spectacular view of the sea and a panorama of the resort centre. They are furnished with a king size bed and a sofabed.",
      "junior-suit-description":
        "The Junior Suites consist of a bedroom and a spacious living-room, combined in an open plan, with a panoramic view of the sea. Furnished with a king size bed and a sofabed.",
      "boutique-apartment-description":
        "This luxury boutique apartment with magnificent sea views is located on the 9th floor.With the stylish design and an impressive decor, the boutique consists of 2 bedrooms, two bathrooms with shower, open plan living area with kitchen three balconies overlooking the sea, a dining table and a huge sofa located in front of a 75 inch TV.",
      rooms: "Rooms",
      sea: "Sea",
      park: "Park",

      // Navigation tabs
      home: "Home",
      about: "About us",
      room: "Rooms",
      events: "Events",
      offers: "Offers",
      reviews: "Reviews",
      gallery: "Gallery",
      contact: "Contact us",
      services: "Services",
      sport: "Recreation and Sport",

      // Home
      welcome: "Welcome to",
      "hotel-admiral": "Hotel Admiral",
      "one-sentence-about":
        "Welcome to Hotel Admiral – the iconic 5-star beachfront hotel in Golden Sands. Here, contemporary luxury, impeccable service, and breathtaking views of the Black Sea come together to create a truly unforgettable stay.",
      "one-sentence-about-2":
        "Discover a place where comfort, gastronomy, relaxation, and special moments blend effortlessly into one complete seaside experience.",

      // About
      "about-text-one":
        "Recently transformed into a modern 5-star retreat, Hotel Admiral stands among the most prestigious properties on the Bulgarian Black Sea coast. Its elegant design, premium facilities, and exceptional beachfront location create a refined atmosphere where every detail matters.",
      "about-text-two":
        "Whether you are here to unwind, enjoy a family holiday, or celebrate a special occasion, Admiral offers a stay that consistently exceeds expectations.",
      "about-text-three": "",

      // Rooms
      "rooms-description-1":
        "Designed with space, light, and comfort in mind, each room and suite at Hotel Admiral offers a calm and elegant retreat by the sea. Modern interiors and carefully selected amenities ensure a relaxing and effortless stay.",
      "rooms-description-2":
        "Wake up to the sound of the sea and enjoy the comfort of a space designed entirely around your well-being.",

      // Dining intro
      "dining-intro-1":
        "Dining at Hotel Admiral is a journey through flavours from around the world. Our restaurants and bars combine high-quality ingredients, refined presentation, and inviting atmospheres for every moment of the day.",
      "dining-intro-2":
        "From generous breakfasts to elegant dinners overlooking the sea, every meal becomes part of your holiday experience.",

      // Services names
      "own-beach": "Beach",
      "outdoor-pool": "Pool",
      parking: "Parking",
      "pool-table": "Pool table",
      "lobby-bar": "Lobby bar",
      "grill-service": "BBQ",
      "piano-bar-service": "Piano bar",
      "rent-bicycle-service": "Rent a bicycle",
      "amore-service": "aMore Moonlight",
      confectionery: "Viennese Patisserie",
      "confectionery-working-hours": "Working hours - 09:00 - 23:00",

      "bar-mezzanine": "Lounge Piano bar",
      fitness: "Fitness",
      vault: "Vault",
      "currency-exchange": "Currency exchange",
      restaurant: "Admiral",
      restaurants: "Restaurants",
      conference: "Conference rooms",
      laundry: "Laundry",
      wifi: "Wifi",
      breakfast: "Breakfast",
      spa: "AquaBliss Spa & Beauty",
      minibar: "Minibar",
      ergonomic: "Ergonomic matress",
      "TV-55": "Digital TV 55 ″",
      "TV-75": "Digital TV 75 ″",
      nespresso: "Nespresso machine",
      cosmetics: "Aqua dellËlba cosmetics",
      AC: "Air conditioner",
      balcon: "Balcony",
      "TV-32": "Digital TV 32 ″",
      armchair: "Extendable armchair",
      "coffee-machine": "Coffee-machine",
      couch: "Couch",
      "touch-light": "Touch lights",

      // Sport
      "admiral-beach": "Admiral Beach",
      "admiral-beach-text-1":
        "With direct access to the beach and spacious pool areas, Hotel Admiral offers the perfect setting for sun-filled days by the Black Sea. Everything here is designed for effortless summer living.",
      "admiral-beach-text-2":
        "Enjoy the rhythm of the sea, from sunrise to sunset.",
      "admiral-beach-working-hours": "Working hours: 08:00 - 17:30",
      "outdoor-swimming-pool": "Outdoor swimming pool",
      "outdoor-swimming-pool-text":
        "The large outdoor swimming pool in front of the hotel, situated on the very beach, is one of the favourite places where hotel guests can unwind. Furnished with numerous parasols and comfortable chaise longues, the pool gives the guest the opportunity to enjoy the sea breeze and the sound of the waves only meters away from the hotel reception.",
      "outdoor-swimming-pool-working-hours": "Working hours: 08:00 - 17:00",
      gym: "Gym",
      "gym-text-1":
        "Stay active during your stay with a modern fitness centre and opportunities for movement and recreation. Balance relaxation with energy in a setting designed for both.",
      "gym-text-2": "Because well-being is about harmony, not compromise.",
      "gym-working-hours": "Working hours: 08:00 - 20:00",
      "indoor-swimming-pool": "Indoor swimming pool with mineral water",
      "indoor-swimming-pool-text":
        "For the delightful and relaxing stay of its guests, Hotel Admiral has provided an indoor pool with mineral water, accessible on rainy days, located on a separate floor in the building.",
      "indoor-swimming-pool-working-hours": "Working hours: 08:00 - 20:00",
      "spa-text-1":
        "AquaBliss Spa is a serene escape dedicated to relaxation and inner balance. A combination of modern treatments, calming atmosphere, and professional care creates a complete wellness experience for body and mind.",
      "spa-text-2":
        "Unwind, recharge, and reconnect with yourself in a space designed for pure relaxation.",
      "bicycle-rent": "Rent a bicycle",
      "bicycle-rent-text":
        "Rent a bicycle, it's a great way to spend an active day and weekend. Cycling is a fun, efficient and easy way of getting around Golden sands - just like the locals do! Even if you only pedal around for a few hours, riding a bike is an essential Golden sands experience. The best efficient way to get around the resort is by bike. If you are interested in sightseeing by bike, we have some great bike tour suggestions. Renting a bike in Golden sands is pretty easy. We rent bikes for an hour or a day, although the most common rental is for up to 3 hours. When you rent a bike, you will put down a deposit.",
      "bicycle-rent-working-hours": "Working hours - 24/7",

      // Events
      parties: "Weddings and corporate parties",
      "parties-text-1":
        "The Admiral offers a multifunctional hall suitable for balls, weddings and corporate parties.",
      "parties-text-2":
        "The hotel staff will come up with ideas and offer a professional approach for the perfect organisation and realisation of the event.",
      conferences: "Conferences and business events",
      "conferences-text-1":
        "From business meetings to private celebrations, Hotel Admiral offers elegant venues, modern technology, and professional service at every step.",
      "conferences-text-2":
        "We create the perfect environment for meaningful events and lasting impressions.",
      "conferences-text-3": "",
      "conferences-text-4": "",

      "check-availability": "Check availability",
      "contact-us": "Contact us",
      "useful-links": "Useful links",
      "email-address": "Email address",
      name: "First Name",
      "last-name": "Last Name",
      subject: "Subject",
      message: "Message",
      "send-message": "Send a message",
      telephone: "Phone number",
      email: "Email",
      address: "Address",
      fax: "fax",
      "add-review": "Add review",
      send: "Send",
      "general-terms": "Terms and Conditions",
      privacy: "Privacy Policy",
      terms: "Booking Terms",
      seminars: "Seminars",
      accommodation: "Accommodation",
      "check-in": "Check - in",
      "check-out": "Check -out",
      children: "Children",
      child: "Child",
      guests: "Guests",
      book: "Book",
      beds: "Beds",
      "room-size": "Room size",
      capacity: "Capacity",
      price: "Price",
      night: "Night",
      "night-singular": "night",
      "nights-plural": "nights",
      all: "All",
      hotel: "Hotel",
      pool: "Pool",
      dining: "Dining",
      bar: "Bar",
      beach: "Beach",
      "room-details": "Room Details",
      azzurro: "Azzurro",
      "asian-samba": "Asian samba Bar & Dinner",
      amore: "aMore Moonlight",
      tortuga: "Tortuga Beach Club",
      "affair-bbq": "Аffair BBQ beach",

      "more-about-us": "More about us",
      "hotel-address": "9007 Golden Sands, Varna",
      "all-rights-reserved": "Hotel Admiral. All rights reserved",
      "see-more": "See more",
      "clients-say": "What do clients say",

      // Restaurant page
      "restaurant-text":
        "The main restaurant offers a rich variety of international specialities, show cooking stations, and themed evenings that turn every meal into a true culinary event.",
      "restaurant-text-2":
        "Once a week you can enjoy our themed Bulgarian and Italian dinner.",
      "restaurant-working-hours": "Working hours:",
      "restaurant-working-hours-1": "Breakfast buffet - 07:30 - 10:00",
      "restaurant-working-hours-2": "Lunch buffet - 12:30 - 14:30",
      "restaurant-working-hours-3": "Dinner buffet - 18:00 - 21:00",
      "lobby-bar-text":
        "Located in the heart of the hotel, our lobby bar offers a wide selection of coffee specialties, refreshing cocktails , premium drinks, perfect for a cool relax after a long day or for meeting friends.",
      "lobby-bar-working-hours": "Working hours - 24/7",
      "confectionery-text":
        "A place for sweet indulgences, aromatic coffee, and moments of calm throughout the day.",
      "bar-mezzanine-text":
        "A stylish evening atmosphere, signature cocktails, and music that turn every night into a special experience.",
      "bar-mezzanine-text-2": "",
      "bar-mezzanine-text-3": "",
      "bar-mezzanine-working-hours": "Working hours - 20:30 - 22:30",
      "swim-up": "Swim-up Pool Bar",
      "swim-up-text":
        "The Admiral Hotel's Swim-up Pool Bar is the perfect place for a refreshing break and unforgettable summer moments. Enjoy the unique experience of sipping cocktails and refreshing drinks without leaving the pool. Our bar offers a variety of exotic cocktails, fresh juices and snacks that will satisfy your tastes while you enjoy the sun and the water. In an ideal combination of relaxation and fun, the Swim-up Pool Bar creates the perfect atmosphere for relaxation and entertainment. Come and enjoy the summer in style at the Swim-up Pool Bar at the Admiral Hotel!",
      "swim-up-working-hours": "Working hours - 09:00 – 18:00",
      "azzurro-text":
        "Inspired by the Mediterranean, Azzurro combines fresh flavours, an elegant atmosphere, and magnificent sea views for an unforgettable gastronomic experience.",
      "azzurro-text-2":
        "1 complimentary dinner for guests staying a minimum of 7 nights - with a minimum of 1 day's prior reservation at reception",
      "asian-samba-text":
        "A modern interpretation of Asian cuisine with rich aromas, refined presentation, and a selection of beloved flavours from the Far East.",
      "asian-samba-text-2": "",
      "amore-text":
        "Introducing a breathtaking experience that will sweep you off your feet and carrying you to a world of enchantment - our exclusive Romantic Dinner at the Beach, hosted at aMore Moonlight Restaurant, nestled at the beach infront Admiral Hotel. As you settle into your intimate beachfront table, adorned with delicate candlelight and exquisite floral arrangements, you'll be greeted by our warm and attentive staff, dedicated to ensuring every moment of your evening is filled with magic. Whether you're celebrating a special occasion, surprising your partner with a heartfelt gesture, or simply indulging in an unforgettable experience, our Romantic Dinner at the Beach at aMore Moonlight Restaurant is the epitome of romance and luxury. Immerse yourself in the beauty of nature, exquisite cuisine, and the blissful connection with your loved one. Book your table now at the receptiondesk and let us create an evening that will forever be etched in your hearts, leaving you with memories that will be cherished for a lifetime.",
      "amore-text-2":
        "1 free dinner for guests with a stay of minimum 7 nights - by prior reservation minimum of 1 day before at reception desk",
      "amore-text-3":
        '"Amore moonlight" dinner – candlelight dinner is possible in high season (July, August) and according to the weather forecast.',
      "tortuga-text":
        "A la carte surf & turf restaurant - with prior reservation for an additional fee. Only Admiral Hotel guests enjoy a special discount of 10% off menu prices. Get ready to discover the full Tortuga experience - from the shared celebration to the intimate dining and well-being.                                                                           This season, you'll have the opportunity to embark on a culinary journey like no other, as we've prepared many new additions to our menu, as well as our new breakfast menu. We look forward to seeing you there!",
      "tortuga-text-2": "",
      "tortuga-text-3": "",
      "affair-bbq-text": "Grill bar on the beach",

      "azzurro-working-hours-1": "Brunch 10:30 - 12:00",
      "azzurro-working-hours": "Lunch 12:30 - 14:30",
      "azzurro-working-hours-2": "Dinner 19:30 - 22:30",
      "asian-samba-working-hours": "Dinner 19:00 - 22:00",
      // "asian-samba-working-hours-2": "Bar - until 00:30h",
      "amore-working-hours": "Dinner 20:30 - 22:30h",
      "amore-note": "The restaurant is open in July and August",
      "affair-working-hours": "Lunch 12:30 - 14:30h",
      "tortuga-working-hours": "Working hours: 10:00 - 00:00",

      payment: "Payment",
      pay: "Pay",
      "card-details": "Card details",
      details: "Details",
      "payment-success": "Successfull payment",
      "payment-fail": "Payment failed",
      pricing: "Pricing",
      meters: "m²",

      "booking-summary": "Booking summary",
      bgn: "BGN",
      view: "View",
      showerhead: "Showerhead",
      tv: "TV",
      conditioner: "Air conditioner",
      dryer: "Hair dryer",
      phone: "Phone",
      adults: "Adults",
      wrong: "Something went wrong",
      "send-review-success": "Successfully sent your review!",
      "send-email-success": "Successfully sent your message!",
      "send-email-fail": "There was a problem sending your message!",
      "no-offers": "There are no offers at the moment.",
      "invalid-period": "Please select valid period.",
      reservations: "Reservations",
      cancellation: "Cancel booking",
      "ref-number": "Reference number",
      "ref-not-found": "Invalid reference number",
      "booking-cancelled": "Booking cancelled",
      apply: "Apply",
      "not-found": "There is no voucher found.",
      voucher: "Voucher",
      "voucher-expired": "The voucher is expired",
      "wrong-room-type": "The voucher can't be used for this type of room",
      "voucher-success": "Voucher successfully applied",
      "no-room-found": "No available rooms for the chosen period",
      size: "Size",
      "capacity-single": "Capacity",
      "total-price": "Total price",
      continue: "Continue",
      "dates-were-booked": "The dates are already booked",
      "no-rooms": "No available rooms for the desired period.",
      "view-room": "View room",

      "our-rooms": "Our rooms",

      "required-field": "The field is required!",
      "room-number": "№ rooms",
      "year-cap": "(to 11.99y)",
      "rooms-and-suites": "Rooms & Suites",
      "valid-name": "Please enter your name.",
      "valid-email": "Please enter valid email address",
      "valid-text": "Please enter some text.",
      "additional-services": "Additional services",
      "choose-adults": "Please select a number of adults.",
      "room-single": "room",
      "already-paid":
        "The reservation is already paid. Please, contact us for more information.",
      "cannot-cancel":
        "The reservation cannot be cancelled. Please, contact us for more information.",
      "type-reference-number": "Please, provide a reference number",
      "already-cancelled": "The booking is already cancelled.",
      subscribe: "Subscribe now",
      newsletter: "Newsletter",
      "invalid-email": "Invalid email address",
      "subscribe-success": "Successfully subscribed to our newsletter!",
      reserve: "Book now",
      "food-board": "Board Basis Type",
      "bed-and-breakfast": "Bed & Breakfast",
      "half-board": "Half Board",
      "full-board": "Full Board",
      "all-light": "All-inclusive light",
      sqm: "m2",
      "send-inquiry": "Send Inquiry",
      "ultra-all-inclusive": "Ultra All Inclusive",
      "ultra-all-inclusive-text-1":
        "Our Ultra All Inclusive concept is designed to give you complete freedom and comfort. Enjoy diverse cuisine, premium drinks, and carefully curated services throughout your stay.",
      "ultra-all-inclusive-text-2":
        "Everything is included, so you can simply relax and enjoy.",
      "final-cta-title": "Discover the Luxury. Discover Admiral.",
      "final-cta-text-1":
        "More than a holiday – a complete seaside experience defined by elegance, comfort, and attention to detail.",
      "final-cta-text-2": "Your 5-star stay begins here.",
      "enjoy-dream-vacation": "Your 5-star stay begins here.",

      "voucher-min-nights":
        "The voucher can be used for bookings of a minimum of {{minNights}} nights",

      gallery_all: "All",
      gallery_hotel: "Hotel",
      gallery_rooms: "Rooms",
      gallery_wiener_cafe: "Viennese Cafe",
      gallery_asian_restaurant: "Asian Restaurant",
      gallery_azzurro: "Azzurro",
      gallerry_piano_bar: "Piano Bar",
      gallerry_pool_bar_and_beach: "Pool Bar & Beach",
      gallerry_fitness_and_spa: "Fitness & Spa",
      authenticating_payment: "Payment authentication in progress",

      cant_accomodate_with_children:
        "The selected rooms do not have capacity for {{adults}} adults and {{children}} children. Please select more rooms!",
      cant_accomodate:
        "The selected rooms do not have capacity for {{adults}} adults. Please select more rooms!",
      ny_min_stay: "Minimum stay of 3 nights",
    },
  },
  de: {
    translation: {
      // Room names
      "double-standard-deluxe": "Doppelzimmer Standard  DeLuxe",
      "double-sea-deluxe": "Doppelzimmer mit Aussicht aufs Meer DeLuxe",
      "double-sea-superior-deluxe": "Doppelzimmer Meer Superior DeLuxe",
      "junior-suit-deluxe": "Junior Suite DeLuxe",
      "apartment-deluxe": "Appartment DeLuxe",
      "double-standard-park": "Doppelzimmer Standard",
      "double-standard-sea": "Doppelzimmer Meer",
      "double-standard-sea-superior": "Doppelzimmer Meer Superior",
      "junior-suit": "Junior Suite",
      "boutique-apartment": "Boutique-Apartment",

      // Room descriptions
      "double-standard-deluxe-description":
        "Die komplett renovierten Zimmer verbinden stilvolles Design mit moderner Technologie, die Zimmer verfügen über ein Doppelbett /king size/ oder zwei Einzelbetten.",
      "double-sea-deluxe-description":
        "Die komplett renovierten Zimmer verbinden stilvolles Design mit moderner Technologie und bieten einen atemberaubenden Meerblick. Sie verfügen über ein Doppelbett /king size/ oder zwei Einzelbetten.",
      "double-sea-superior-deluxe-description":
        "Geräumig und komfortabel, komplett renoviert, mit einer Kombination aus stilvollem Design und moderner Technologie, bieten die Zimmer einen atemberaubenden Meerblick. Sie verfügen über ein Doppelbett /king size/ und ein Ausziehsofa. ",
      "junior-suit-deluxe-description":
        "Die komplett renovierten junior Suite Appartments mit feiner Atmosphäre und modernem Design bestehen aus einem Schlafzimmer und einem geräumigen Wohnzimmer, die zu einem großen Raum mit Panoramablick aufs Meer verschmolzen sind. Sie verfügen über ein Doppelbett /king size/ und ein Ausziehsofa.",
      "apartment-deluxe-description":
        "Die Appartments  wurden komplett renoviert und befinden sich in der obersten neunten Etage des Hotels. Sie verfügen über ein feines Dekor und ein unverwechselbares Design. Sie bestehen aus einem Wohnzimmer und einem Schlafzimmer und bieten einen einzigartigen Panoramablick auf den Strand und die Ortschaft. Sie verfügen über ein Doppelbett /king-size/ und ein Ausziehsofa.",
      "double-standard-park-description":
        "Die geräumigen und hellen Standard-Doppelzimmer vereinen ein komfortables Design und alle Bequemlichkeiten für einen vollwertigen Aufenthalt. Die Zimmer verfügen über zwei Einzelbetten.",
      "double-standard-sea-description":
        "Die elegant eingerichteten Doppelzimmer mit Aussicht aufs Meer bieten modernsten Komfort. Sie zeichnen sich durch ihren einzigartigen Aussicht aufs Meer aus. Die Zimmer verfügen über zwei Einzelbetten.",
      "double-standard-sea-superior-description":
        "Die Superior-Doppelzimmer bieten einen atemberaubenden Meerblick und Panoramablick auf das Zentrum der Ortschaft. Sie verfügen über ein Doppelbett /king size/ und ein Ausziehsofa.",
      "junior-suit-description":
        "Die Appartments  junior Suite bestehen aus einem Schlafzimmer und einem geräumigen Wohnzimmer, die zu einem geräumigen Raum mit Panoramablick auf das Meer verschmolzen sind. Sie verfügen über ein Doppelbett  / king size/ und ein Ausziehsofa.",
      "boutique-apartment-description":
        "Dieses luxuriöse Boutique-Apartment mit herrlichem Meerblick befindet sich im 9. Stock. Entworfen in einem stilvollen Design, mit einem beeindruckenden Dekor, besteht die Boutique aus 2 Schlafzimmern, zwei Badezimmern mit Dusche, einem offenen Wohnbereich mit Küche. drei Balkone mit Meerblick, ein Esstisch und ein riesiges Sofa vor einem 75-Zoll-Fernseher",

      // Tabs
      home: "Startseite",
      about: "Über uns",
      accommodation: "Unterkunft",
      dining: "Lokale",
      events: "Events",
      offers: "Angebote",
      reviews: "Bewertungen",
      gallery: "Bildergalerie",
      contact: "Kontakt",
      services: "Ausstattung",
      sport: "Erholung und Sport",

      // Room info
      room: "Zimmer",
      rooms: "Räume",
      sea: "Meer",
      park: "Park",

      // Home
      welcome: "Willkommen zu",
      "hotel-admiral": "Hotel Admiral",
      "one-sentence-about":
        "Willkommen im Hotel Admiral – dem ikonischen 5-Sterne-Hotel direkt am Strand von Goldstrand. Hier verbinden sich moderner Luxus, erstklassiger Service und ein beeindruckender Blick auf das Schwarze Meer zu einem unvergesslichen Aufenthalt.",
      "one-sentence-about-2":
        "Erleben Sie einen Ort, an dem Komfort, Kulinarik, Entspannung und besondere Momente zu einem harmonischen Gesamterlebnis verschmelzen.",

      // About
      "about-text-one":
        "Nach seiner umfassenden Modernisierung gehört das Hotel Admiral zu den renommiertesten 5-Sterne-Häusern an der bulgarischen Schwarzmeerküste. Elegantes Design, hochwertige Ausstattung und die direkte Lage am Strand schaffen eine exklusive Atmosphäre.",
      "about-text-two":
        "Ob Erholung, Familienurlaub oder besonderer Anlass – das Admiral bietet Erlebnisse, die Ihre Erwartungen übertreffen.",
      "about-text-three": "",

      // Rooms
      "rooms-description-1":
        "Die Zimmer und Suiten sind großzügig gestaltet und verbinden modernes Design mit Komfort und Ruhe. Helle Räume, elegante Details und durchdachte Ausstattung sorgen für einen entspannten Aufenthalt.",
      "rooms-description-2":
        "Wachen Sie mit Meerblick auf und genießen Sie ein Ambiente voller Ruhe und Eleganz.",

      // Dining intro
      "dining-intro-1":
        "Die Kulinarik im Hotel Admiral führt Sie durch internationale Geschmackswelten. Unsere Restaurants und Bars bieten hochwertige Küche, stilvolle Präsentation und eine angenehme Atmosphäre.",
      "dining-intro-2":
        "Von einem reichhaltigen Frühstück bis zum Abendessen mit Meerblick wird jede Mahlzeit zu einem besonderen Erlebnis.",
      // Services
      wifi: "Wi-Fi",
      minibar: "minibar",
      ergonomic: "Ergonomische Matratzen",
      balcon: "Balkon",
      telephone: "Telefon",
      "TV-75": "Interaktives Fernsehen/ Bildschirm 75 inch /",
      "TV-55": "Interaktives Fernsehen/ Bildschirm 55 inch /",
      "TV-32": "Interaktives Fernsehen/ Bildschirm 32 inch /",
      vault: "Tresor",
      nespresso: `Kaffeemaschine Nespresso`,
      cosmetics: "Kosmetik Aqua dellËlba",
      AC: "Klimaanlage",
      armchair: "Ausziehsofa",
      couch: "Haartrockner",
      "touch-light": "Smart Beleuchtung",
      "coffee-machine": "Kaffeemaschine",
      showerhead: "Duschkabine / Badewanne",
      spa: "AquaBliss Spa",
      breakfast: "Frühstück",

      "own-beach": "Strand",
      "outdoor-pool": "Außenpool",
      parking: "Parken",
      "pool-table": "Billardtisch",
      "lobby-bar": "Lobby-Bar",
      "grill-service": "Grill",
      "piano-bar-service": "Pianobar",
      "rent-bicycle-service": "Mieten Sie ein Fahrrad",
      "amore-service": "aMore Moonlight",
      confectionery: "Wiener Patisserie",
      "confectionery-working-hours": "Öffnungszeit – 09:00 – 23:00",

      "bar-mezzanine": "Lounge Piano bar",
      fitness: "Fitnessraum",
      "currency-exchange": "Wechselstube",
      restaurant: "Admiral",
      restaurants: "Restaurants",
      conference: "Konferenzräume",
      laundry: "Wäscheservice",

      // Sport
      "admiral-beach": "Strand Admiral",
      "admiral-beach-text-1":
        "Mit direktem Zugang zum Strand und großzügigen Poolbereichen bietet das Hotel Admiral ideale Bedingungen für erholsame Tage am Meer.",
      "admiral-beach-text-2":
        "Genießen Sie Sonne, Meer und unbeschwerte Sommermomente.",
      "admiral-beach-working-hours": "Öffnungszeit: 08:00 - 17:30",
      "outdoor-swimming-pool": "Außenpool",
      "outdoor-swimming-pool-text":
        "Der große Außenpool vor dem Hotel, liegend direkt am Strand, ist einer der Lieblingsorte für Erholung der Hotelgäste. Ausgestattet mit mehreren Sonnenschirmen und bequemen Liegestühlen, bietet der Pool den Gästen die Möglichkeit an, die Meeresbrise und den Meeresgeräusch, nur Metern vom Hotel entfernt, zu genießen.",
      "outdoor-swimming-pool-working-hours": "Öffnungszeit: 08:00 - 17:00",
      gym: "Fitnessraum",
      "gym-text-1":
        "Bleiben Sie aktiv – auch im Urlaub. Der moderne Fitnessbereich bietet Ihnen die Möglichkeit, Bewegung und Entspannung zu kombinieren.",
      "gym-text-2": "Denn wahre Erholung bedeutet Ausgleich.",
      "gym-working-hours": "Öffnungszeit: 08:00 - 20:00",
      "indoor-swimming-pool": "Innenpool mit Mineralwasser",
      "indoor-swimming-pool-text":
        "Für den angenehmen und erholsamen Aufenthalt seiner Gäste verfügt das Hotel Admiral über einen Innenpool mit Mineralwasser, der an Regentagen zugänglich ist und sich auf einer separaten Etage im Gebäude befindet.",
      "indoor-swimming-pool-working-hours": "Öffnungszeit: 08:00 - 20:00",
      "spa-text-1":
        "Das AquaBliss Spa ist ein Ort der Ruhe und Regeneration. Moderne Anwendungen, entspannende Atmosphäre und professionelle Betreuung schaffen ein ganzheitliches Wohlgefühl.",
      "spa-text-2": "Hier finden Körper und Geist zurück in ihre Balance.",
      "bicycle-rent": "Mieten Sie ein Fahrrad",
      "bicycle-rent-text":
        "Leihen Sie sich ein Fahrrad, um einen aktiven Tag oder ein Wochenende zu verbringen. Radfahren ist eine unterhaltsame, effiziente und einfache Art, sich in Golden Sands fortzubewegen - so wie es die Einheimischen tun! Selbst wenn Sie nur für ein paar Stunden in die Pedale treten, ist das Radfahren ein wesentliches Erlebnis in Golden Sands. Die beste Art, sich im Ferienort fortzubewegen, ist mit dem Fahrrad. Wenn Sie sich für Sightseeing mit dem Fahrrad interessieren, haben wir einige tolle Vorschläge für Radtouren. Ein Fahrrad in Golden Sands zu mieten ist ziemlich einfach. Wir vermieten Fahrräder für eine Stunde oder einen Tag, wobei die gängigste Mietdauer bis zu 3 Stunden beträgt. Wenn Sie ein Fahrrad mieten, müssen Sie eine Kaution hinterlegen.",
      "bicycle-rent-working-hours": "Öffnungszeit – 24/7",

      // Events
      parties: "Hochzeiten und Firmenfeiern",
      "parties-text-1":
        "Das Hotel Admiral verfügt über einen multifunktionalen Raum, geeignet für Festbälle, Hochzeiten und Firmenfeiern.",
      "parties-text-2":
        "Das Hotelteam wird mit Ideen und Professionalismus für die perfekte Organisation und die Durchführung der Veranstaltung entgegenkommen.",
      conferences: "Konferenze und business meetings",
      "conferences-text-1":
        "Ob geschäftlich oder privat – das Hotel Admiral bietet stilvolle Veranstaltungsräume, moderne Technik und perfekten Service.",
      "conferences-text-2":
        "Wir schaffen den passenden Rahmen für erfolgreiche und unvergessliche Veranstaltungen.",
      "conferences-text-3": "",
      "conferences-text-4": "",

      "check-availability": "Die Verfügbarkeit prüfen",
      "contact-us": "Kontakt",
      "useful-links": "Nützliche Links",
      "email-address": "E-Mail addresse",
      name: "Name",
      "last-name": "Nachname",
      subject: "Thema",
      message: "Botschaft",
      "send-message": "Nachricht senden",
      email: "E-Mail",
      address: "Addresse",
      fax: "Fax",
      "add-review": "Bewertung hinzufügen",
      send: "Senden",
      "general-terms": "Bedingungen und Konditionen",
      privacy: "Datenschutz",
      terms: "Nutzungsbedingungen",
      seminars: "Seminare",
      "check-in": "Einchecken",
      "check-out": "Auschecken",
      children: "Kinder",
      child: "Kind",
      guests: "Gäste",
      book: "Buchen",
      beds: "Betten",
      "room-size": "Zimmergröße",
      capacity: "Raumkapazität",
      price: "Preis",
      night: "Nacht",
      "night-singular": "Nacht",
      "nights-plural": "Nächte",
      all: "Alle",
      hotel: "Hotel",
      pool: "Pool",
      bar: "Bar",
      beach: "Strand",
      "room-details": "Zimmerdetails",
      azzurro: "Azzurro",
      "asian-samba": "Asiatisches Restaurant",
      amore: "aMore Moonlight",
      tortuga: "Tortuga Beach Club",
      "affair-bbq": "Аffair BBQ strand",

      "more-about-us": "Mehr über uns",
      "hotel-address": "9007 Golden Strand, Varna",
      "all-rights-reserved": "Hotel Admiral. Alle Rechte vorbehalten",
      "see-more": "Mehr sehen",
      "clients-say": "Bewertung unserer Gäste",

      // Restaurandouble-standart-superior-junior.jpgts page
      "restaurant-text":
        "Das Hauptrestaurant bietet eine reiche Vielfalt internationaler Spezialitäten, Show-Cooking-Stationen und Themenabende, die jede Mahlzeit zu einem echten kulinarischen Erlebnis machen.",
      "restaurant-text-2":
        "Einmal pro Woche können Sie unser bulgarisches und italienisches Themenabendessen genießen.",
      "restaurant-working-hours": "Öffnungszeit:",
      "restaurant-working-hours-1": "Frühstücksbuffet – 07:30 – 10:00",
      "restaurant-working-hours-2": "Mittagsbuffet – 12:30 – 14:30",
      "restaurant-working-hours-3": "Abendbuffet – 18:00 – 21:00",
      "lobby-bar-text":
        "Im Herzen des Hotels gelegen, bietet unsere Lobby-Bar eine große Auswahl an Kaffeespezialitäten, erfrischenden Cocktails und erstklassigen Getränken, ideal für eine kühle Entspannung nach einem langen Tag oder um Freunde zu treffen.",
      "lobby-bar-working-hours": "Öffnungszeit – 24/7",
      "confectionery-text":
        "Ein Ort für süße Genüsse, aromatischen Kaffee und Momente der Ruhe den ganzen Tag über.",
      "bar-mezzanine-text":
        "Stilvolle Abendatmosphäre, Signature-Cocktails und Musik, die jeden Abend zu einem besonderen Erlebnis machen.",
      "bar-mezzanine-text-2": "",
      "bar-mezzanine-text-3": "",
      "bar-mezzanine-working-hours": "Öffnungszeit – 20:30 – 22:30",
      "swim-up": "Swim-up-Poolbar",
      "swim-up-text":
        "Die Swim-up Pool Bar des Admiral Hotels ist der perfekte Ort für eine erfrischende Pause und unvergessliche Sommermomente. Genießen Sie das einzigartige Erlebnis, Cocktails und erfrischende Getränke zu schlürfen, ohne den Pool zu verlassen. Unsere Bar bietet eine Auswahl an exotischen Cocktails, frischen Säften und Snacks, die Ihren Geschmack treffen, während Sie die Sonne und das Wasser genießen. In einer idealen Kombination aus Entspannung und Spaß schafft die Swim-up Pool Bar die perfekte Atmosphäre für Erholung und Unterhaltung. Kommen Sie und genießen Sie den Sommer mit Stil an der Swim-up Pool Bar im Admiral Hotel!",
      "swim-up-working-hours": "Öffnungszeit - 09:00 – 18:00",
      "azzurro-text":
        "Vom Mittelmeer inspiriert, verbindet Azzurro frische Aromen, elegante Atmosphäre und einen herrlichen Meerblick zu einem unvergesslichen gastronomischen Erlebnis.",
      "azzurro-text-2":
        "1 kostenloses Abendessen für Gäste mit einem Mindestaufenthalt von 7 Nächten - mit einer Reservierung von mindestens 1 Tag im Voraus an der Rezeption",
      "asian-samba-text":
        "Eine moderne Interpretation der asiatischen Küche mit reichen Aromen, eleganter Präsentation und einer Auswahl beliebter Geschmacksrichtungen aus dem Fernen Osten.",
      "asian-samba-text-2": "",
      "amore-text":
        "Wir stellen Ihnen ein atemberaubendes Erlebnis vor, das Sie umhauen und in eine Welt voller Zauber entführen wird – unser exklusives romantisches Abendessen am Strand, veranstaltet im aMore Moonlight Restaurant, direkt am Strand vor dem Admiral Hotel. Wenn Sie sich an Ihrem gemütlichen Tisch am Strand niederlassen, der mit zartem Kerzenlicht und exquisiten Blumenarrangements geschmückt ist, werden Sie von unserem herzlichen und aufmerksamen Personal begrüßt, das dafür sorgt, dass jeder Moment Ihres Abends voller Magie ist. Egal, ob Sie einen besonderen Anlass feiern, Ihren Partner mit einer herzlichen Geste überraschen oder sich einfach ein unvergessliches Erlebnis gönnen, unser romantisches Abendessen am Strand im aMore Moonlight Restaurant ist der Inbegriff von Romantik und Luxus. Tauchen Sie ein in die Schönheit der Natur, die exquisite Küche und die glückselige Verbindung mit Ihrem Liebsten. Reservieren Sie jetzt Ihren Tisch an der Rezeption und lassen Sie uns einen Abend gestalten, der für immer in Ihrem Herzen verankert sein wird und Ihnen Erinnerungen hinterlassen wird, die Sie ein Leben lang schätzen werden.",
      "amore-text-2":
        "1 kostenloses Abendessen für Gäste mit einem Aufenthalt von mindestens 7 Nächten - nach vorheriger Reservierung mindestens 1 Tag vorher an der Rezeption.",
      "amore-text-3":
        '"Amore moonlight" - Abendessen bei Kerzenlicht ist in der Hochsaison (Juli, August) und je nach Wettervorhersage möglich.',
      "tortuga-text":
        "la carte surf & turf restaurant - with prior reservation for an additional fee. Only Admiral Hotel guests enjoy a special discount of 10% off menu prices. Get ready to discover the full Tortuga experience - from the shared celebration to the intimate dining and well-being.                                                                           This season, you'll have the opportunity to embark on a culinary journey like no other, as we've prepared many new additions to our menu, as well as our new breakfast menu. We look forward to seeing you there!",
      "tortuga-text-2": "",
      "tortuga-text-3": "",
      "affair-bbq-text": "Grillen am Strand",

      "azzurro-working-hours-1": "Brunch 10:30 - 12:00",
      "azzurro-working-hours": "Mittagessen 12:30 - 14:30",
      "azzurro-working-hours-2": "Abendessen 19:30 - 22:30",
      "asian-samba-working-hours": "Abendessen 19:00 - 22:00",
      // "asian-samba-working-hours-2": "Bar bis 00:30",
      "amore-working-hours": "Abendessen 20:30 - 22:30",
      "amore-note": "Das Restaurant ist im Juli und August geöffnet",
      "affair-working-hours": "Mittagessen 12:30 - 14:30",
      "tortuga-working-hours": "Öffnungszeit 10:00 - 00:00",

      payment: "Zahlung",
      pay: "Zahlen",
      "card-details": "Kartendetails",
      details: "Einzelheiten",
      "payment-success": "Erfolgreiche Zahlung",
      "payment-fail": "Zahlung fehlgeschlagen",
      pricing: "Preise",
      meters: "m²",
      "booking-summary": "Zusammenfassung",
      bgn: "BGN",
      view: "Aussicht",
      tv: "Fernseher",
      conditioner: "Klimaanlage",
      dryer: "Haartrockner",
      phone: "Telefon",
      adults: "Erwachsene",
      wrong: "Etwas ist schief gelaufen",
      "send-review-success": "Sie haben Ihre Bewertung erfolgreich gesendet!",
      "send-email-success": "Sie haben Ihre Nachricht erfolgreich gesendet!",
      "send-email-fail": "Es gab ein Problem beim Senden Ihrer Nachricht!",
      "no-offers": "Keine Angebote gefunden.",
      "invalid-period": "Bitte wählen Sie einen gültigen Zeitraum.",
      reservations: "Reservierungen",
      cancellation: "Reservierung stornieren",
      "ref-number": "Referenznummer",
      "ref-not-found": "Ungültige Referenznummer",
      "booking-cancelled": "Buchung storniert",
      apply: "Anwenden",
      "not-found": "Kein Gutschein gefunden.",
      "voucher-expired": "Der Gutschein ist abgelaufen.",
      "wrong-room-type":
        "Gutschein kann für diesen Zimmertyp nicht verwendet werden.",
      voucher: "Gutschein",
      "voucher-success": "Der Gutschein wurde erfolgreich angewendet.",
      "no-room-found": "Keine Zimmer für den gewählten Zeitraum verfügbar",
      size: "Bereich",
      "capacity-single": "Bereich",
      "total-price": "Gesamtkosten",
      continue: "Mach weiter",
      "dates-were-booked": "Die ausgewählten Termine sind vergeben.",
      "no-rooms": "Keine Zimmer für den gewählten Zeitraum verfügbar.",
      "view-room": "Zimmer ansehen",

      "our-rooms": "Unsere Zimmer",

      "required-field": "Das Feld ist obligatorisch!",
      "room-number": "Anzahl der Räume",
      "year-cap": "(bis 11.99J.)",
      "rooms-and-suites": `Zimmer & Appartements`,

      "valid-name": "Bitte geben Sie Ihren Namen ein.",
      "valid-email": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      "valid-text": "Bitte Text eingeben",
      "additional-services": "Zusätzliche Dienstleistungen",
      "choose-adults": "Personenanzahl (Erwachsene)",

      "room-single": "Zimmer",
      "already-paid":
        "Die Buchung ist bezahlt. Kontaktieren Sie uns gerne, wenn Sie Unterstützung benötigen.",
      "cannot-cancel":
        "The reservation cannot be cancelled. Please, contact us for more information.",
      "type-reference-number": "Geben Sie bitte eine Buchungsnummer ein.",
      "already-cancelled": "Diese Buchung wurde bereits storniert.",
      subscribe: "Hier abonnieren",
      newsletter: "Abonnenten",
      "invalid-email": "Ungültige Mailadresse",
      subscribers: "Абонати",
      "subscribe-success":
        "Sie haben sich erfolgreich für unseren Newsletter abonniert.",
      reserve: "Buchen",
      "food-board": "Verpflegung",
      "bed-and-breakfast": "Frühstück",
      "half-board": "Halbpension",
      "full-board": "Vollpension",
      "all-light": "Alles-inklusive light",
      sqm: "m2",
      "send-inquiry": "Anfrage senden",
      "ultra-all-inclusive": "Ultra All Inclusive",
      "ultra-all-inclusive-text-1":
        "Unser Ultra All Inclusive Konzept steht für sorglosen Genuss auf höchstem Niveau. Kulinarik, Getränke und Service sind perfekt aufeinander abgestimmt.",
      "ultra-all-inclusive-text-2": "Einfach ankommen und genießen.",
      "final-cta-title": "Discover the Luxury. Discover Admiral.",
      "final-cta-text-1":
        "Mehr als nur Urlaub – ein exklusiver Aufenthalt direkt am Meer.",
      "final-cta-text-2": "Ihr 5-Sterne-Erlebnis beginnt hier.",
      "enjoy-dream-vacation": "Ihr 5-Sterne-Erlebnis beginnt hier.",
      "voucher-min-nights":
        "Der Gutschein kann für Buchungen von mindestens {{minNights}} Nächten verwendet werden",

      gallery_all: "Alle",
      gallery_hotel: "Hotel",
      gallery_rooms: "Räume",
      gallery_wiener_cafe: "Wiener Café",
      gallery_asian_restaurant: "Asiatisches Restaurant",
      gallery_azzurro: "Azzurro",
      gallerry_piano_bar: "Piano Bar",
      gallerry_pool_bar_and_beach: "Pool Bar & Strand",
      gallerry_fitness_and_spa: "Fitness & Spa",
      authenticating_payment: "Zahlungsauthentifizierung läuft",
      cant_accomodate_with_children:
        "Die ausgewählten Zimmer haben nicht die Kapazität für {{adults}} Erwachsene und {{children}} Kinder. Bitte wählen Sie mehr Zimmer!",
      cant_accomodate:
        "Die ausgewählten Zimmer haben nicht die Kapazität für {{adults}} Erwachsene. Bitte wählen Sie mehr Zimmer!",
      ny_min_stay: "Mindestaufenthalt 3 Nächte",
    },
  },
  ro: {
    translation: {
      "double-standard-deluxe": "Cameră dublă standard DeLuxe",
      "double-sea-deluxe": "Cameră dublă DeLuxe cu vedere la mare",
      "double-sea-superior-deluxe":
        "Cameră dublă superior DeLuxe cu vedere la mare",
      "junior-suit-deluxe": "Junior suite DeLuxe",
      "apartment-deluxe": "Apartament DeLuxe",
      "double-standard-park": "Cameră dublă standard",
      "double-standard-sea": "Cameră dublă cu vedere la mare",
      "double-standard-sea-superior": "Cameră dublă superior cu vedere la mare",
      "junior-suit": "Junior Suite",
      "boutique-apartment": "Apartament boutique",
      "double-standard-deluxe-description":
        "Complet renovate, combinând un design elegant și tehnologii moderne, camerele sunt mobilate cu un pat king size sau două paturi single.",
      "double-sea-deluxe-description":
        "Complet renovate, combinând un design elegant și tehnologii moderne, camerele oferă o priveliște impresionantă către mare. Toate camerele au un pat king size sau două paturi single.",
      "double-sea-superior-deluxe-description":
        "Spațioase, confortabile și complet renovate, combinând un design elegant cu tehnologii moderne, camerele oferă o priveliște captivantă către mare. Camerele sunt mobilate cu un pat king size și o canapea extensibilă.",
      "junior-suit-deluxe-description":
        "Complet renovate, remarcabile prin atmosfera elegantă și designul modern, suitele Junior constau dintr-un dormitor și un living spațios în plan deschis, cu vedere panoramică la mare. Mobilate cu un pat king size și o canapea extensibilă.",
      "apartment-deluxe-description":
        "Complet renovate și situate la ultimul etaj al hotelului, aceste suite se remarcă prin interiorul sofisticat și designul distinctiv. Constau dintr-un living și un dormitor și oferă o panoramă de neegalat asupra plajei și stațiunii. Mobilate cu un pat king size și o canapea extensibilă.",
      "double-standard-park-description":
        "Spațioase și luminoase, camerele duble standard oferă un design confortabil și toate facilitățile necesare pentru un sejur plăcut. Camerele sunt mobilate cu două paturi single.",
      "double-standard-sea-description":
        "Mobilate elegant, camerele duble cu vedere la mare oferă toate conforturile moderne. Se remarcă prin priveliștea unică către mare. Camerele sunt mobilate cu două paturi single.",
      "double-standard-sea-superior-description":
        "Camerele duble superior oferă o priveliște spectaculoasă către mare și o panoramă asupra centrului stațiunii. Sunt mobilate cu un pat king size și o canapea extensibilă.",
      "junior-suit-description":
        "Suitele Junior constau dintr-un dormitor și un living spațios, combinate într-un plan deschis, cu vedere panoramică la mare. Mobilate cu un pat king size și o canapea extensibilă.",
      "boutique-apartment-description":
        "Acest apartament boutique de lux, cu priveliști magnifice către mare, este situat la etajul 9. Cu un design elegant și o decorațiune impresionantă, boutique-ul constă din 2 dormitoare, două băi cu duș, living deschis cu bucătărie, trei balcoane cu vedere la mare, o masă de dining și o canapea mare amplasată în fața unui televizor de 75 inch.",
      rooms: "Camere",
      sea: "Mare",
      park: "Parc",

      // Navigation tabs
      home: "Pagina principală",
      about: "Despre hotel",
      room: "Camere",
      events: "Evenimente",
      offers: "Oferte",
      reviews: "Recenzii",
      gallery: "Galerie",
      contact: "Contact",
      services: "Facilități",
      sport: "Sport și recreere",
      accommodation: "Cazare",
      dining: "Restaurante",

      // Home
      welcome: "Bine ați venit la",
      "hotel-admiral": "Hotel Admiral",
      "one-sentence-about":
        "Bine ați venit la Hotel Admiral – hotelul emblematic de 5 stele de pe plaja din Nisipurile de Aur. Aici, luxul modern, serviciile impecabile și priveliștile spectaculoase către Marea Neagră se îmbină într-un sejur memorabil.",
      "one-sentence-about-2":
        "Descoperiți un loc unde confortul, gastronomia, relaxarea și momentele speciale se completează perfect într-o experiență completă la malul mării.",

      // About
      "about-text-one":
        "Recent modernizat, Hotel Admiral se numără printre cele mai prestigioase hoteluri de pe litoralul bulgăresc al Mării Negre. Designul elegant, facilitățile premium și poziționarea excelentă pe plajă creează o atmosferă rafinată.",
      "about-text-two":
        "Fie că doriți relaxare, vacanță în familie sau o ocazie specială, Admiral oferă experiențe care depășesc așteptările.",
      "about-text-three": "",

      // Rooms
      "rooms-description-1":
        "Camerele și suitele sunt spațioase, luminoase și concepute pentru confort maxim. Designul modern și facilitățile atent alese oferă un sejur relaxant și elegant.",
      "rooms-description-2":
        "Treziți-vă cu vedere la mare și bucurați-vă de liniște și rafinament.",

      // Dining intro
      "dining-intro-1":
        "Experiența culinară de la Hotel Admiral vă poartă prin arome internaționale variate. Restaurantele și barurile combină ingrediente de calitate, prezentare elegantă și atmosferă plăcută.",
      "dining-intro-2":
        "De la mic dejun bogat până la cine rafinate pe malul mării, fiecare masă devine o experiență.",

      // Services names
      "own-beach": "Plajă",
      "outdoor-pool": "Piscină",
      parking: "Parcare",
      "pool-table": "Biliard",
      "lobby-bar": "Bar lobby",
      "grill-service": "BBQ",
      "piano-bar-service": "Bar cu pian",
      "rent-bicycle-service": "Închiriere biciclete",
      "amore-service": "aMore Moonlight",
      confectionery: "Patiserie vieneză",
      "confectionery-working-hours": "Program de funcționare - 09:00 - 23:00",

      "bar-mezzanine": "Lounge Piano bar",
      fitness: "Fitness",
      vault: "Seif",
      "currency-exchange": "Schimb valutar",
      restaurant: "Admiral",
      restaurants: "Restaurante",
      conference: "Săli de conferință",
      laundry: "Spălătorie",
      wifi: "Wi-Fi",
      breakfast: "Mic dejun",
      spa: "AquaBliss Spa & Beauty",
      minibar: "Minibar",
      ergonomic: "Saltea ergonomică",
      "TV-55": "Televizor digital 55 ″",
      "TV-75": "Televizor digital 75 ″",
      nespresso: "Aparat Nespresso",
      cosmetics: "Cosmetice Aqua dellËlba",
      AC: "Aer condiționat",
      balcon: "Balcon",
      "TV-32": "Televizor digital 32 ″",
      armchair: "Fotoliu extensibil",
      "coffee-machine": "Aparat de cafea",
      couch: "Canapea",
      "touch-light": "Iluminare touch",

      // Sport
      "admiral-beach": "Plaja Admiral",
      "admiral-beach-text-1":
        "Cu acces direct la plajă și zone spațioase de piscină, Hotel Admiral oferă cadrul perfect pentru zile pline de soare la Marea Neagră. Totul aici este conceput pentru o vară fără griji.",
      "admiral-beach-text-2":
        "Bucurați-vă de ritmul mării, de răsărit la apus.",
      "admiral-beach-working-hours": "Program: 08:00 - 17:30",
      "outdoor-swimming-pool": "Piscină exterioară",
      "outdoor-swimming-pool-text":
        "Piscina exterioară amplă din fața hotelului, situată chiar pe plajă, este unul dintre locurile preferate de relaxare ale oaspeților. Echipată cu numeroase umbrele și șezlonguri confortabile, piscina le oferă oaspeților posibilitatea de a se bucura de briza mării și de sunetul valurilor, la doar câțiva metri de recepția hotelului.",
      "outdoor-swimming-pool-working-hours": "Program: 08:00 - 17:00",
      gym: "Sală de fitness",
      "gym-text-1":
        "Rămâneți activ în timpul sejurului cu un centru de fitness modern și oportunități de mișcare și recreere. Echilibrați relaxarea cu energia într-un cadru conceput pentru ambele.",
      "gym-text-2": "Pentru că starea de bine înseamnă armonie, nu compromis.",
      "gym-working-hours": "Program: 08:00 - 20:00",
      "indoor-swimming-pool": "Piscină interioară cu apă minerală",
      "indoor-swimming-pool-text":
        "Pentru un sejur plăcut și relaxant, Hotel Admiral pune la dispoziție o piscină interioară cu apă minerală, accesibilă în zilele ploioase, situată la un etaj separat în clădire.",
      "indoor-swimming-pool-working-hours": "Program: 08:00 - 20:00",
      "spa-text-1":
        "AquaBliss Spa este un refugiu liniștit dedicat relaxării și echilibrului interior. O combinație de tratamente moderne, atmosferă calmă și îngrijire profesională creează o experiență completă de wellness pentru corp și minte.",
      "spa-text-2":
        "Relaxați-vă, reîncărcați-vă și reconectați-vă cu voi înșivă într-un spațiu conceput pentru relaxare pură.",
      "bicycle-rent": "Închiriere biciclete",
      "bicycle-rent-text":
        "Închiriați o bicicletă – este o modalitate excelentă de a petrece o zi activă și un weekend plin de energie. Ciclismul este o modalitate distractivă, eficientă și ușoară de a vă deplasa prin Nisipurile de Aur – exact ca localnicii! Chiar dacă pedalați doar câteva ore, mersul cu bicicleta este o experiență esențială la Nisipurile de Aur. Cea mai eficientă modalitate de a explora stațiunea este cu bicicleta. Dacă sunteți interesat de vizite turistice cu bicicleta, avem câteva sugestii excelente de tururi. Închirierea unei biciclete la Nisipurile de Aur este destul de simplă. Închiriem biciclete pe oră sau pe zi, deși cea mai frecventă închiriere este de până la 3 ore. Când închiriați o bicicletă, veți lăsa un depozit.",
      "bicycle-rent-working-hours": "Program - 24/7",

      // Events
      parties: "Nunți și evenimente corporate",
      "parties-text-1":
        "Hotel Admiral dispune de o sală multifuncțională potrivită pentru baluri, nunți și evenimente corporate.",
      "parties-text-2":
        "Echipa hotelului va răspunde cu idei și profesionalism pentru organizarea și desfășurarea perfectă a evenimentului.",
      conferences: "Conferințe și evenimente de business",
      "conferences-text-1":
        "Hotel Admiral oferă spații elegante și servicii profesionale pentru evenimente corporate sau private.",
      "conferences-text-2":
        "Creăm cadrul ideal pentru momente importante și reușite.",
      "conferences-text-3": "",
      "conferences-text-4": "",

      "check-availability": "Verifică disponibilitatea",
      "contact-us": "Contactați-ne",
      "useful-links": "Linkuri utile",
      "email-address": "Adresă de e-mail",
      name: "Prenume",
      "last-name": "Nume",
      subject: "Subiect",
      message: "Mesaj",
      "send-message": "Trimite un mesaj",
      telephone: "Număr de telefon",
      email: "E-mail",
      address: "Adresă",
      fax: "Fax",
      "add-review": "Adăugați o recenzie",
      send: "Trimite",
      "general-terms": "Termeni și condiții",
      privacy: "Politica de confidențialitate",
      terms: "Termeni de rezervare",
      seminars: "Seminarii",
      "check-in": "Check-in",
      "check-out": "Check-out",
      children: "Copii",
      child: "Copil",
      guests: "Oaspeți",
      book: "Rezervă",
      beds: "Paturi",
      "room-size": "Dimensiune cameră",
      capacity: "Capacitate",
      price: "Preț",
      night: "Noapte",
      "night-singular": "noapte",
      "nights-plural": "nopți",
      all: "Toate",
      hotel: "Hotel",
      pool: "Piscină",
      bar: "Bar",
      beach: "Plajă",
      "room-details": "Detalii cameră",
      azzurro: "Azzurro",
      "asian-samba": "Asian samba Bar & Dinner",
      amore: "aMore Moonlight",
      tortuga: "Tortuga Beach Club",
      "affair-bbq": "Аffair BBQ beach",

      "more-about-us": "Mai multe despre noi",
      "hotel-address": "9007 Nisipurile de Aur, Varna",
      "all-rights-reserved": "Hotel Admiral. Toate drepturile rezervate",
      "see-more": "Vezi mai mult",
      "clients-say": "Ce spun clienții",

      // Restaurant page
      "restaurant-text":
        "Restaurantul principal oferă o varietate bogată de specialități internaționale, stații de show cooking și seri tematice care transformă fiecare masă într-un adevărat eveniment culinar.",
      "restaurant-text-2":
        "O dată pe săptămână vă puteți bucura de cina noastră tematică bulgară și italiană.",
      "restaurant-working-hours": "Program de funcționare:",
      "restaurant-working-hours-1": "Bufet mic dejun - 07:30 - 10:00",
      "restaurant-working-hours-2": "Bufet prânz - 12:30 - 14:30",
      "restaurant-working-hours-3": "Bufet cină - 18:00 - 21:00",
      "lobby-bar-text":
        "Situat în inima hotelului, barul nostru lobby oferă o selecție largă de specialități de cafea, cocktailuri răcoritoare și băuturi premium, perfecte pentru o relaxare plăcută după o zi lungă sau pentru întâlniri cu prietenii.",
      "lobby-bar-working-hours": "Program - 24/7",
      "confectionery-text":
        "Un loc pentru delicii dulci, cafea aromată și momente de liniște pe tot parcursul zilei.",
      "bar-mezzanine-text":
        "O atmosferă elegantă de seară, cocktailuri signature și muzică care transformă fiecare seară într-o experiență specială.",
      "bar-mezzanine-text-2": "",
      "bar-mezzanine-text-3": "",
      "bar-mezzanine-working-hours": "Program - 20:30 - 22:30",
      "swim-up": "Swim-up Pool Bar",
      "swim-up-text":
        "Swim-up Pool Bar de la Hotel Admiral este locul perfect pentru o pauză răcoritoare și momente de vară de neuitat. Bucurați-vă de experiența unică de a savura cocktailuri și băuturi răcoritoare fără a părăsi piscina. Barul nostru oferă o varietate de cocktailuri exotice, sucuri proaspete și gustări care vă vor satisface gusturile în timp ce vă bucurați de soare și apă. Într-o combinație ideală de relaxare și distracție, Swim-up Pool Bar creează atmosfera perfectă pentru odihnă și entertainment. Veniți și savurați vara cu stil la Swim-up Pool Bar de la Hotel Admiral!",
      "swim-up-working-hours": "Program - 09:00 – 18:00",
      "azzurro-text":
        "Inspirat de Mediterana, Azzurro combină arome proaspete, o atmosferă elegantă și o priveliște magnifică către mare pentru o experiență gastronomică de neuitat.",
      "azzurro-text-2":
        "1 cină gratuită pentru oaspeții care se cazează minimum 7 nopți – cu rezervare cu cel puțin 1 zi în avans la recepție",
      "asian-samba-text":
        "O interpretare modernă a bucătăriei asiatice, cu arome bogate, prezentare rafinată și o selecție de gusturi preferate din Orientul Îndepărtat.",
      "asian-samba-text-2": "",
      "amore-text":
        "Vă prezentăm o experiență uluitoare care vă va purta într-o lume a farmecului – cina noastră romantică exclusivă pe plajă, găzduită la restaurantul aMore Moonlight, situat pe plajă, în fața Hotelului Admiral. Când vă așezați la masa intimă de pe plajă, împodobită cu lumânări delicate și aranjamente florale rafinate, veți fi întâmpinați de personalul nostru cald și atent, dedicat să facă fiecare moment al serii plin de magie. Fie că sărbătoriți o ocazie specială, surprindeți partenerul cu un gest plin de suflet sau pur și simplu vă răsfățați cu o experiență de neuitat, cina noastră romantică pe plajă la aMore Moonlight Restaurant este epitomul romantismului și luxului. Cufundați-vă în frumusețea naturii, bucătăria rafinată și conexiunea fericită cu persoana iubită. Rezervați masa acum la recepție și lăsați-ne să creăm o seară care va rămâne pentru totdeauna în inimile voastre, lăsându-vă amintiri prețioase pentru o viață.",
      "amore-text-2":
        "1 cină gratuită pentru oaspeții cu un sejur de minimum 7 nopți – cu rezervare prealabilă cu minimum 1 zi înainte la recepție",
      "amore-text-3":
        'Cina „Amore moonlight" – cină la lumina lumânărilor este posibilă în sezonul de vârf (iulie, august) și în funcție de prognoza meteo.',
      "tortuga-text":
        "Restaurant à la carte surf & turf – cu rezervare prealabilă, contra unei taxe suplimentare. Doar oaspeții Hotelului Admiral beneficiază de o reducere specială de 10% din prețurile meniului. Pregătiți-vă să descoperiți experiența completă Tortuga – de la sărbătorile împărtășite la mesele intime și momentele de relaxare. În acest sezon, veți avea ocazia să porniți într-o călătorie culinară ca nicio alta, deoarece am pregătit multe noutăți în meniul nostru, precum și noul meniu de mic dejun. Așteptăm cu nerăbdare să vă vedem acolo!",
      "tortuga-text-2": "",
      "tortuga-text-3": "",
      "affair-bbq-text": "Grill bar pe plajă",

      "azzurro-working-hours-1": "Brunch 10:30 - 12:00",
      "azzurro-working-hours": "Prânz 12:30 - 14:30",
      "azzurro-working-hours-2": "Cină 19:30 - 22:30",
      "asian-samba-working-hours": "Cină 19:00 - 22:00",
      // "asian-samba-working-hours-2": "Bar - until 00:30h",
      "amore-working-hours": "Cină 20:30 - 22:30",
      "amore-note": "Restaurantul este deschis în iulie și august",
      "affair-working-hours": "Prânz 12:30 - 14:30",
      "tortuga-working-hours": "Program: 10:00 - 00:00",

      payment: "Plată",
      pay: "Plătește",
      "card-details": "Detalii card",
      details: "Detalii",
      "payment-success": "Plată reușită",
      "payment-fail": "Plata a eșuat",
      pricing: "Prețuri",
      meters: "m²",

      "booking-summary": "Rezumat rezervare",
      bgn: "BGN",
      view: "Vedere",
      showerhead: "Duș",
      tv: "TV",
      conditioner: "Aer condiționat",
      dryer: "Uscător de păr",
      phone: "Telefon",
      adults: "Adulți",
      wrong: "Ceva nu a funcționat",
      "send-review-success": "Recenzia dvs. a fost trimisă cu succes!",
      "send-email-success": "Mesajul dvs. a fost trimis cu succes!",
      "send-email-fail": "A apărut o problemă la trimiterea mesajului!",
      "no-offers": "Nu există oferte în acest moment.",
      "invalid-period": "Vă rugăm să selectați o perioadă validă.",
      reservations: "Rezervări",
      cancellation: "Anulează rezervarea",
      "ref-number": "Număr de referință",
      "ref-not-found": "Număr de referință invalid",
      "booking-cancelled": "Rezervare anulată",
      apply: "Aplică",
      "not-found": "Nu s-a găsit niciun voucher.",
      voucher: "Voucher",
      "voucher-expired": "Voucherul a expirat",
      "wrong-room-type":
        "Voucherul nu poate fi utilizat pentru acest tip de cameră",
      "voucher-success": "Voucher aplicat cu succes",
      "no-room-found": "Nu există camere disponibile pentru perioada aleasă",
      size: "Suprafață",
      "capacity-single": "Capacitate",
      "total-price": "Preț total",
      continue: "Continuă",
      "dates-were-booked": "Datele sunt deja rezervate",
      "no-rooms": "Nu există camere disponibile pentru perioada dorită.",
      "view-room": "Vezi camera",

      "our-rooms": "Camerele noastre",

      "required-field": "Câmpul este obligatoriu!",
      "room-number": "Nr. camere",
      "year-cap": "(până la 11,99 ani)",
      "rooms-and-suites": "Camere & Suite",
      "valid-name": "Vă rugăm să introduceți numele.",
      "valid-email": "Vă rugăm să introduceți o adresă de e-mail validă",
      "valid-text": "Vă rugăm să introduceți un text.",
      "additional-services": "Servicii suplimentare",
      "choose-adults": "Vă rugăm să selectați numărul de adulți.",
      "room-single": "cameră",
      "already-paid":
        "Rezervarea este deja plătită. Vă rugăm să ne contactați pentru mai multe informații.",
      "cannot-cancel":
        "Rezervarea nu poate fi anulată. Vă rugăm să ne contactați pentru mai multe informații.",
      "type-reference-number": "Vă rugăm să furnizați un număr de referință",
      "already-cancelled": "Rezervarea este deja anulată.",
      subscribe: "Abonați-vă acum",
      newsletter: "Newsletter",
      "invalid-email": "Adresă de e-mail invalidă",
      "subscribe-success": "V-ați abonat cu succes la newsletter-ul nostru!",
      reserve: "Rezervă acum",
      "food-board": "Tip masă",
      "bed-and-breakfast": "Cazare cu mic dejun",
      "half-board": "Demipensiune",
      "full-board": "Pensiune completă",
      "all-light": "All-inclusive light",
      sqm: "m2",
      "send-inquiry": "Trimite o solicitare",
      "ultra-all-inclusive": "Ultra All Inclusive",
      "ultra-all-inclusive-text-1":
        "Conceptul Ultra All Inclusive oferă libertate totală și confort deplin, cu servicii atent gândite pentru o experiență fără griji.",
      "ultra-all-inclusive-text-2":
        "Tot ce trebuie să faceți este să vă bucurați de vacanță.",
      "final-cta-title": "Descoperiți luxul. Descoperiți Admiral.",
      "final-cta-text-1":
        "Mai mult decât o vacanță – o experiență premium la malul mării.",
      "final-cta-text-2": "Șederea dumneavoastră de 5 stele începe aici.",
      "enjoy-dream-vacation": "Șederea dumneavoastră de 5 stele începe aici.",

      "voucher-min-nights":
        "Voucherul poate fi utilizat pentru rezervări de minimum {{minNights}} nopți",

      gallery_all: "Toate",
      gallery_hotel: "Hotel",
      gallery_rooms: "Camere",
      gallery_wiener_cafe: "Cafenea vieneză",
      gallery_asian_restaurant: "Restaurant asiatic",
      gallery_azzurro: "Azzurro",
      gallerry_piano_bar: "Bar cu pian",
      gallerry_pool_bar_and_beach: "Bar piscină și plajă",
      gallerry_fitness_and_spa: "Fitness & Spa",
      authenticating_payment: "Autentificare plată în curs",

      cant_accomodate_with_children:
        "Camerele selectate nu au capacitate pentru {{adults}} adulți și {{children}} copii. Vă rugăm să selectați mai multe camere!",
      cant_accomodate:
        "Camerele selectate nu au capacitate pentru {{adults}} adulți. Vă rugăm să selectați mai multe camere!",
      ny_min_stay: "Sejur minim de 3 nopți",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
